import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const DeliveryCanceledItem = ({ data }) => {
    const payload = data.payload || {};
    const customer = payload.customer || {};

    return (
        <ListItem>
            <i className="material-icons" style={{color: 'red'}}>close</i>
            <ListItemText primary={`Cancelou entrega para ${customer.name}`} />
        </ListItem>
    );

}

export default DeliveryCanceledItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Delivery/Canceled.js